<template>
  <div class="mom-subapp-outlet"></div>
</template>

<script>
export default {
  name: 'MomSubappOutlet'
}
</script>
